// Shared loading-window rule for RAG document ingestion (spec §6/§11). A doc still pending/processing
// past this age means the worker never finished — almost always the system was shut down mid-ingest.
// Past the cutoff, callers stop the spinner + polling rather than spinning forever against a dead
// pipeline. Used by the admin Knowledge-documents card and the chat attach chips, so the rule lives once.
export const LOADING_TIMEOUT_MS = 60 * 60 * 1000; // 1 hour

/** True while a doc that started ingesting at [startedAtMs] (ms epoch) is still within the loading window. */
export const withinLoadingWindow = (startedAtMs: number): boolean =>
  Date.now() - startedAtMs < LOADING_TIMEOUT_MS;
